import { EventAction } from '../EventAction';
import { getService } from 'data/function';
import { catchAction } from '../EventReceiver';
export class LoadingProcessor {
    /**
     * Used as getter because angular injector function maybe not available
     * in the moment that this class is evaluated
     */
    static get LoadingService() {
        return getService('LoadingService');
    }
    /**
     * Process postMessage event from iframe
     * @param action
     */
    static process({ message }) {
        const action = catchAction(message.action);
        switch (action) {
            case EventAction.StartLoading:
                LoadingProcessor.LoadingService.startLoading(false);
                break;
            case EventAction.StopLoading:
                LoadingProcessor.LoadingService.stopLoading();
                break;
            default:
                throw new Error('Unrecognized LoadingProcessor action');
        }
    }
}
